import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/nft/NFISH.png'


const _withScopeId = n => (_pushScopeId("data-v-14856387"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nft-item"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createTextVNode("Loading"),
  /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "...")
], -1))
const _hoisted_3 = { class: "name-row" }
const _hoisted_4 = { class: "price-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "token-img",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 20 NFISH ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getNftDetail } from '@/common/ipfs/nft';
import {
  NFTDetail,
  getNftImgById,
  NFTData,
  NFT,
} from '@/configs/nft';


export default /*#__PURE__*/_defineComponent({
  props: {
    nftData: null,
    nft: null
  },
  emits: ['to-detail'],
  setup(__props: any, { emit }) {

const props = __props as {
  nftData: NFTData,
  nft: NFT,
}





const nftImg = getNftImgById(props.nft.nftId);

const nftDetail = ref<NFTDetail>({
  id: '',
  nftType1: '',
  nftType2: '',
  animation_url: '',
  attributes: [],
  description: '',
  external_url: '',
  image: '',
  name: '',
});

const router = useRouter();

function initData() {
  getNftDetail(props.nft.metadataUrl).then((nft: NFTDetail) => {
    nftDetail.value = nft;
  });
}
initData();

function toDetail() {
  emit('to-detail');
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (props.nftData.quantity === undefined || props.nftData.quantity > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "card",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toDetail()))
        }, [
          _createVNode(_component_el_image, {
            src: _unref(nftImg),
            fit: "contain",
            class: _normalizeClass(['illustration', { 'dark': props.nftData.dark }])
          }, {
            placeholder: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["src", "class"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t(nftDetail.value.name)) + " ", 1),
          (props.nftData.quantity)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("×" + _toDisplayString(props.nftData.quantity), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_7, 512), [
          [_vShow, props.nftData.price]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})